import { CdkConnectedOverlay } from "@angular/cdk/overlay";
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, TemplateRef, ViewChild } from "@angular/core";
import { VButtonComponent } from "@directives/_core/v-button/v-button.component";
import { fromEvent, Subscription } from "rxjs";
import "./v-button-dropdown.component.scss";

@Component({
    selector: "v-button-dropdown",
    template: require("./v-button-dropdown.component.html")
})
export class VButtonDropdownComponent extends VButtonComponent implements OnDestroy {

    @Input() label: string = "Custom Filter";
    @Input() autoSize: boolean;
    @Input() showMask: boolean;
    @Input() template: TemplateRef<any>;

    @Output() close = new EventEmitter();

    // ---

    @ViewChild('overlay') overlay: CdkConnectedOverlay;

    // ---

    private outsideClickSubscriptions: Subscription;

    constructor(cd: ChangeDetectorRef, elementRef: ElementRef<HTMLElement>) {
        super(cd, elementRef);
        this.usingCdkPortal = true;
    }


    ngOnDestroy(): void {
        this.removeListener();
    }

    toggleDropdown(): void {
        if (this.showDropDown) {
            this.closeDropdown();
        }
        else {
            this.showDropDown = true;
            this.createListener();
        }
    }

    closeDropdown(): void {
        if (!this.showDropDown) {
            return;
        }

        this.showDropDown = false;
        this.close.emit();
        this.removeListener();
    }

    onOutsideClick(): void {
        this.showDropDown = true;
        this.closeDropdown();
    }

    // ---

    private createListener(): void {

        this.outsideClickSubscriptions = fromEvent(document.body, 'click',
            {
                capture: true,
            })
            .subscribe((event: MouseEvent) => {
                if (!this.overlay?.overlayRef?.hostElement.contains(event.target as any)) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    this.closeDropdown();

                    return true;
                }
            });
    }

    private removeListener(): void {

        this.outsideClickSubscriptions?.unsubscribe();
    }
}
